module.exports = __webpack_public_path__ + "components/flag/static/square/gt-6dad9cc64fc45cc361f37a4bac41eace.svg";